import React, { memo, useContext, useEffect, useState, createContext, useRef, useMemo } from "react";
import { PlusOutlined, LeftCircleOutlined, RightCircleOutlined, DeleteOutlined, LoadingOutlined, FolderOpenOutlined, UploadOutlined, DownOutlined, ExclamationCircleFilled, MoreOutlined } from "@ant-design/icons";
import { Button, Image, Popconfirm, Upload, Modal, Tree, theme, Space, Dropdown, Input } from "antd";
import ImageService from "services/image";
import FolderService from "services/folder";

import { useApp } from "contexts/app";
import { CSS } from "@dnd-kit/utilities";
import "./MultiImagePicker.css";
import { useAuth } from "contexts/auth";
import _, { forEach } from "lodash"
import ImagePickerContext from "./ImagePickerContext"
import FolderPicker from "./FolderPicker"
const { useToken } = theme;



const ImageModal = ({ open, onOk, onCancel }) => {
    const { folder, setFolder } = useContext(ImagePickerContext);
    const { value, maxPhotos, acceptedFormats, maxFileSize, onChange } = useContext(ImagePickerContext)
    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const fileInputRef = useRef();
    const newFolderNameInputref = useRef();
    const [treeData, setTreeData] = useState([])
    const [showCreateFolder, setShowCreateFolder] = useState(false);
    const [folderList, setFolderList] = useState([])
    const [selectedTreeKeys, setSelectedTreeKeys] = useState(['root'])
    const [expandedKeys, setExpandedKeys] = useState(['root'])
    const { showNotify, modal, showLoading, prompt } = useApp();
    const [showFolderPicker, setShowFolderPicker] = useState(false)
    const [folderPickerOnSelectFn, setFolderPickerOnSelectFn] = useState({ callback: e => { console.log(e) } })
    const { token } = useToken();
    useEffect(() => {
        if (open) {
            delayLoad(folder);
        }
        setFiles([])
    },
        [open, folder]);


    useEffect(() => {

        loadFolder();

    }, []);

    const loadData = async (folderLoad) => {
        setFiles([])
        const imageService = new ImageService();
        var lst = await imageService.list(folderLoad);
        setFiles(lst)
    }
    const delayLoad = useMemo(() => _.debounce(loadData, 500), []);
    const createChildNode = (id, lst) => {
        var childs = lst.filter(x => x.parent_id == id).map(x => ({ ...x }));

        if (childs.length == 0)
            return null;
        for (let index = 0; index < childs.length; index++) {
            var child = childs[index];
            child.title = child.name;
            child.key = child.id;

            child.children = createChildNode(child.id, lst);

        }
        return childs

    }

    const loadFolder = async () => {
        const service = new FolderService();
        var lst = await service.list();


        const treeData = [
            {
                title: 'Thư Mục Gốc',
                key: 'root',
                children: createChildNode("root", lst),
            },

            {
                title: 'Tất cả',
                key: 'all',
                children: [],
            },
        ];
        setTreeData(treeData);
        setFolderList(lst);
    }




    const onSelect = (selectedKeys, info) => {
        var key = _.last(selectedKeys)
        setFolder(_.last(selectedKeys));
        setSelectedTreeKeys(selectedKeys)

    };

    const onClickImage = (img) => {
        var index = files.findIndex(x => x.id == img.id);
        var lstNew = [...files];
        lstNew[index].selected = !lstNew[index].selected;
        setFiles(lstNew)
    }
    const onSelectImage = () => {
        var selectedList = files.filter(x => x.selected).map(x => {
            var a = { ...x };
            delete a.selected;
            return a;
        })


        var newValue = _.concat((value ?? []), selectedList)
        onChange(newValue);
        onCancel();

    }

    const creaFileSize = async () => {
        const imageService = new ImageService();
        await imageService.createFileSize();
    }



    const uploadImage = async (file) => {
        const imageService = new ImageService();
        try {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("folder", folder);

            const result = await imageService.upload(formData);
            return result;
        } catch (error) {
            error("File  was not uploaded. Please try again later");
            throw error;
        }
    };
    const onFilechange = async (e) => {
        setUploading(true);

        for (let index = 0; index < e.target.files.length; index++) {
            const element = e.target.files[index];
            await uploadImage(element)

        }
        setUploading(false);
        loadData(folder);
    }

    const items = [
        {
            label: 'Xoá',
            key: 'delete_images',
        },
        {
            label: 'Di chuyển',
            key: 'move_images',
        },

    ];



    const folderActions = [

        {
            label: 'Đổi tên',
            key: 'rename_folder',
        },
        {
            label: 'Di chuyển',
            key: 'move_folder',
        },
        {
            label: 'Xoá',
            key: 'delete_folder',
        },


    ];

    const onClick = ({ key }) => {

        switch (key) {
            case "delete_images":
                deleteImages();

                return;

            case "move_images":
                moveImages();

                return;

            default:
                break;
        }
    };

    const deleteImages = async () => {

        modal.confirm({
            title: 'Bạn có chắc chắn muốn xoá các hình này?',
            icon: <ExclamationCircleFilled />,
            // content: 'Some descriptions',
            onOk: async () => {
                var ids = files.filter(x => x.selected).map(x => x.id);
                const imageService = new ImageService();
                showLoading(true);
                await imageService.deleteList(ids);
                await loadData(folder);
                showLoading(false)
            },
            onCancel: () => {
                console.log('Cancel');
            },
        });
    }

    const moveImages = async () => {

        // modal.confirm({
        //     title: 'Bạn có chắc chắn muốn xoá các hình này?',
        //     icon: <ExclamationCircleFilled />,
        //     // content: 'Some descriptions',
        //     onOk: async () => {
        //         var ids = files.filter(x => x.selected).map(x => x.id);
        //         const imageService = new ImageService();
        //         showLoading(true);
        //         await imageService.deleteList(ids);
        //         await loadData(folder);
        //         showLoading(false)
        //     },
        //     onCancel: () => {
        //         console.log('Cancel');
        //     },
        // });


        setShowFolderPicker(true);
        setFolderPickerOnSelectFn({
            callback: async e => {
                var ids = files.filter(x => x.selected).map(x => x.id);

                const imageService = new ImageService();
                showLoading(true);
                await imageService.moveList(ids, e);
                await loadData(folder);
                showLoading(false)

            }
        })



    }


    const footer = () => {
        return (
            <div style={{ width: "100%", display: "flex" }}>
                <div >
                    <input type='file' accept="image/*" multiple onChange={onFilechange} ref={fileInputRef} style={{ display: "none" }} />
                    <Space>

                        {/* <Button icon={<UploadOutlined />} onClick={creaFileSize} loading={uploading}>Test</Button> */}
                    </Space>

                </div>
                <div style={{ flexGrow: 1 }}>


                    <Space>
                        <div style={{ display: "flex", gap: 4 }}>
                            {files.filter(x => x.selected).length > 0 &&
                                <Dropdown menu={{ items, onClick }}>
                                    <a onClick={e => e.preventDefault()}>
                                        <Space>
                                            <MoreOutlined />

                                        </Space>
                                    </a>
                                </Dropdown>
                            }
                            {files.filter(x => x.selected).map(x => {
                                return (
                                    <div onClick={e => onClickImage(x)}>
                                        <img src={x.url} style={{ width: 32, height: 32 }}></img>
                                    </div>
                                )
                            })}

                        </div>
                        <Button onClick={e => setShowCreateFolder(true)}>Tạo folder</Button>
                        <Button icon={<UploadOutlined />} onClick={e => fileInputRef.current.click()} loading={uploading}>Upload</Button>
                        <Button onClick={onSelectImage} type="primary">Ok</Button>
                    </Space>
                </div>
            </div>
        )
    }

    const createFolder = async () => {

        var name = newFolderNameInputref.current.input.value;
        // console.log(newFolderNameInputref.current.input,name)
        const service = new FolderService();
        var createdFolder = await service.create({ name: name, parent_id: folder })
        showNotify(`đã tạo folder ${name}`);
        setShowCreateFolder(false);
        loadFolder();
        setSelectedTreeKeys([createdFolder.id])
        setExpandedKeys([...expandedKeys, folder])
        setFolder(createdFolder.id)

    }

    const getTitle = () => {
        var selectedFolder = folderList.find(x => x.id == folder);
        if (selectedFolder) {
            return (

                <Space>
                    {selectedFolder.name}
                    <Dropdown menu={{ onClick: folderMenuClick, items: folderActions }} trigger={['click']}>
                        <a onClick={e => e.preventDefault()}>
                            <Space>
                                <MoreOutlined />
                            </Space>
                        </a>
                    </Dropdown>
                </Space>
            )

            return selectedFolder.name;
        }

        return "Chọn hình"
    }

    const folderMenuClick = ({ key }) => {
        if (key == "rename_folder") {
            renameFolder();
        }

        if (key == "delete_folder") {
            deleteFolder();
        }

        if (key == "move_folder") {
            moveFolder();
        }
        // alert(key)
    }

    const renameFolder = () => {
        prompt({
            title: "Đổi tên", label: "Nhập tên",
            onOk: async (text) => {
                const service = new FolderService();
                await service.update({ id: folder, name: text });

                loadFolder();
            }
        });
    }


    const deleteFolder = () => {
        modal.confirm({
            title: 'Bạn có chắc chắn muốn xoá folder ?',
            icon: <ExclamationCircleFilled />,
            // content: 'Some descriptions',
            onOk: async () => {
                var selectedFolder = folderList.find(x => x.id == folder);
                if (selectedFolder) {
                    const service = new FolderService();
                    await service.delete(folder);

                    await loadFolder();
                    setFolder(selectedFolder.parent_id)
                }


                // var ids = files.filter(x => x.selected).map(x => x.id);
                // const imageService = new ImageService();
                // showLoading(true);
                // await imageService.deleteList(ids);
                // await loadData(folder);
                // showLoading(false)
            },
            onCancel: () => {
                console.log('Cancel');
            },
        });
    }

    const moveFolder = () => {
        setShowFolderPicker(true);
        setFolderPickerOnSelectFn({
            callback: async e => {

                showLoading(true);
                const service = new FolderService();
                try {
                        await service.update({ id: folder, parent_id: e });
                } catch (error) {
                    
                }
            
                await loadFolder();
                showLoading(false);

            }
        })

    }


    return (
        <>

            <Modal title={getTitle()} open={open} onCancel={onCancel} width={"75vw"} footer={footer} >
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: 200 }}>
                        <Tree
                            defaultExpandedKeys={['root']}
                            defaultSelectedKeys={['root']}
                            selectedKeys={selectedTreeKeys}
                            expandedKeys={expandedKeys}
                            onExpand={keys => setExpandedKeys(keys)}
                            onSelect={onSelect}
                            selectable
                            treeData={treeData}
                            style={{ width: 200, height: 400, overflowY: "scroll" }}
                        />
                    </div>
                    <div style={{ flexGrow: 1, flexShrink: 1 }}>
                        <div style={{ display: "flex", gap: 16, flexDirection: "row", flexWrap: "wrap", width: "100%", height: "50vh", overflow: "scroll" }}>
                            {files.map(file => {
                                return (
                                    <div onClick={e => onClickImage(file)} style={{ padding: 2, borderColor: file.selected ? token.colorPrimary : "transparent", borderWidth: 1, borderStyle: "solid", height: 100, width: 125 }}>
                                        <img

                                            preview={false}
                                            src={file.sm_url}
                                            style={{ objectFit: "cover", width: "100%", height: "100%" }}
                                        />
                                    </div>
                                )
                            })}

                        </div>
                    </div>
                </div>


            </Modal>


            <Modal title="Tạo folder mới" open={showCreateFolder} onCancel={e => setShowCreateFolder(false)} onOk={createFolder}>
                <Input ref={newFolderNameInputref}></Input>

            </Modal>

            <FolderPicker open={showFolderPicker} onCancel={e => setShowFolderPicker(false)} onFolderSelected={e => {
                folderPickerOnSelectFn.callback(e);

            }}></FolderPicker>
        </>
    )
}










export default ImageModal;
